/* eslint-disable @typescript-eslint/no-deprecated */
export type { InfoButtonProps, InfoButtonSlots, InfoButtonState } from './components/InfoButton/index';
export {
  InfoButton,
  infoButtonClassNames,
  renderInfoButton_unstable,
  useInfoButtonStyles_unstable,
  useInfoButton_unstable,
} from './components/InfoButton/index';
